import { createContext, useState } from "react";
import Login from "./Login";
import InnerHTML from "dangerously-set-html-content";
import "tailwindcss/tailwind.css";

import { BrowserRouter as Router, Routes, Route } from "react-router-dom";

import Success from "./payments/PaymentSuccess";
import Failure from "./payments/PaymentFailure";
import Callback from "./payments/Callback";
import AppCentPostback from "./payments/AppCentPostback";
import AppCentFailure from "./payments/AppCentFailute";
import AppCentSuccess from "./payments/AppCentSuccess";
import CapitalistSuccess from "./payments/CapitalistSuccess";
import CapitalistCallback from "./payments/CapitalistCallback";
import CapitalistFailure from "./payments/CapitalistFailure";
import YooKassaPayed from "./YooKassaPayed.tsx";
import "../App.css";

export const LanguageContext = createContext();

function App() {
  const queryParameters = new URLSearchParams(window.location.search);

  const [lang, setLang] = useState(queryParameters.get("la") ?? "ru");

  return (
    <Router>
      <Routes>
        <Route
          exact
          path="/"
          element={
            <LanguageContext.Provider value={[lang, setLang]}>
              <div>
                {lang === "en" ? (
                  <InnerHTML
                    html={`
                    <script>
                    const tableName = "eAIq chat_en";
                    const supabaseData = "eAIq chat_en";
              
                    const firstMessage =
                      "👋 Hey there! Any question? Ask me!";
                    const header = "eAIq chat";
                    const subHeader = "🤖 AI chatbot";
                    const whatsapplink = "https://wa.me/+79826005377";
                    const telegramlink = "https://t.me/holygoose";
                    const messagePopupDelay = 3000;
                    const mainColor = "#16a34a";
                    const humanSpeech = "#4E4F5C";
                    const aiSpeech = "#16a34a";
                    const backgroundColor = "#27272a";
                    const userInputColor = "#ddd";
                    const messageText = "#fff";
                    const closeButton = "#4E4F5C";
                    const supportSpeech = "#66B6FF";
                    const telegramChat = "-1002077617509";
                    const lang = 'en'
                    
                    fetch("https://cyberchat-html.vercel.app/")
                      .then((response) => response.text())
                      .then((htmlContent) => {
                        const container = document.createElement("div");
                        container.innerHTML = htmlContent;
              
                        document.body.appendChild(container);
              
                        const scriptTags = container.getElementsByTagName("script");
                        for (let i = 0; i < scriptTags.length; i++) {
                          const script = document.createElement("script");
                          script.innerHTML = scriptTags[i].innerHTML;
                          document.body.appendChild(script);
                        }
                      })
                      .catch((error) =>
                        console.error("Error fetching external HTML:", error)
                      );
                  </script>`}
                  />
                ) : (
                  <InnerHTML
                    html={`
                    <script>
                    const tableName = "eAIq chat";
                    const supabaseData = "eAIq chat";
              
                    const firstMessage =
                      "👋 Привет! Если будут вопросы - спрашивай!";
                    const header = "eAIq chat";
                    const subHeader = "🤖 AI чат-бот";
                    const whatsapplink = "https://wa.me/+79826005377";
                    const telegramlink = "https://t.me/holygoose";
                    const messagePopupDelay = 3000;
                    const mainColor = "#16a34a";
                    const humanSpeech = "#4E4F5C";
                    const aiSpeech = "#16a34a";
                    const backgroundColor = "#27272a";
                    const userInputColor = "#ddd";
                    const messageText = "#fff";
                    const closeButton = "#4E4F5C";
                    const supportSpeech = "#66B6FF";
                    const telegramChat = "-1002077617509";
                    const lang = 'ru'
                    
                    fetch("https://cyberchat-html.vercel.app/")
                      .then((response) => response.text())
                      .then((htmlContent) => {
                        const container = document.createElement("div");
                        container.innerHTML = htmlContent;
              
                        document.body.appendChild(container);
              
                        const scriptTags = container.getElementsByTagName("script");
                        for (let i = 0; i < scriptTags.length; i++) {
                          const script = document.createElement("script");
                          script.innerHTML = scriptTags[i].innerHTML;
                          document.body.appendChild(script);
                        }
                      })
                      .catch((error) =>
                        console.error("Error fetching external HTML:", error)
                      );
                  </script>`}
                  />
                )}

                <Login></Login>
              </div>
            </LanguageContext.Provider>
          }
        />
        <Route path="/yookassapayed" element={<YooKassaPayed />} />
        {/**Cryptomus */}
        <Route path="/success" element={<Success />} />
        <Route path="/failure" element={<Failure />} />
        <Route path="/callback" element={<Callback />} />
        {/**AppCent */}
        <Route path="/appcent/success" element={<AppCentSuccess />} />
        <Route path="/appcent/failure" element={<AppCentFailure />} />
        <Route path="/appcent/callback" element={<AppCentPostback />} />
        {/**Capitalist */}
        <Route path="/capitalist/success" element={<CapitalistSuccess />} />
        <Route path="/capitalist/failure" element={<CapitalistFailure />} />
        <Route path="/capitalist/callback" element={<CapitalistCallback />} />
      </Routes>
    </Router>
  );
}

export default App;
